export default "__VITE_ASSET__17472e89__"